// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dAnalytics$dTypes$dItem from "../Restaumatic.Analytics.Types.Item/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const PurchaseItem = x => x;
const newtypePurchaseItem_ = {Coercible0: () => {}};
const hasFieldPurchaseItem = dictHasField => dictHasField;
const eqPurchaseItem = {
  eq: x => y => x.affiliation === y.affiliation && (() => {
    if (x.coupon.tag === "Nothing") { return y.coupon.tag === "Nothing"; }
    if (x.coupon.tag === "Just") {
      if (y.coupon.tag === "Just") { return x.coupon._1 === y.coupon._1; }
      return false;
    }
    return false;
  })() && Data$dEq.eqArrayImpl(Restaumatic$dAnalytics$dTypes$dItem.eqItem.eq)(x.items)(y.items) && x.shipping === y.shipping && x.total === y.total && x.transactionId === y.transactionId
};
const genericPurchaseItem = {to: x => x, from: x => x};
const showPurchaseItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(Restaumatic$dAnalytics$dTypes$dItem.showItem.show);
      return {
        genericShowArgs: v => [
          (() => {
            const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["affiliation", Data$dShow.showStringImpl(v.affiliation)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "coupon",
              (() => {
                if (v.coupon.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v.coupon._1) + ")"; }
                if (v.coupon.tag === "Nothing") { return "Nothing"; }
                $runtime.fail();
              })()
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["items", $0(v.items)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "shipping",
              Data$dMoney$dRounded.toString(v.shipping)
            ]))(Data$dShow.cons(Data$dShow.intercalate(": ")(["total", Data$dMoney$dRounded.toString(v.total)]))(Data$dShow.cons(Data$dShow.intercalate(": ")([
              "transactionId",
              Data$dShow.showStringImpl(v.transactionId)
            ]))([]))))));
            if (v$1.length === 0) { return "{}"; }
            return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
          })()
        ]
      };
    })())({reflectSymbol: () => "PurchaseItem"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodePurchaseItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "affiliation"})(Unscramble.decodeString1)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "coupon"
    })(Unscramble.decodeMaybe(Unscramble.decodeString1))(Unscramble.decodeRecordCons({reflectSymbol: () => "items"})({
      unsafeDecode: Unscramble.decodeArray(Restaumatic$dAnalytics$dTypes$dItem.unscrambleDecodeItem.unsafeDecode)
    })(Unscramble.decodeRecordCons({reflectSymbol: () => "shipping"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({reflectSymbol: () => "total"})(Data$dMoney$dRounded.udecodeMoney)(Unscramble.decodeRecordCons({
      reflectSymbol: () => "transactionId"
    })(Unscramble.decodeString1)(Unscramble.decodeRecordNil)))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodePurchaseItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericPurchaseItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor({
    reflectSymbol: () => "PurchaseItem"
  })(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({
      reflectSymbol: () => "transactionId"
    })({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce}))({reflectSymbol: () => "total"})({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({
      reflectSymbol: () => "shipping"
    })({encodeWithOptions: v => Data$dMoney$dRounded.encodeMoney.encode}))({reflectSymbol: () => "items"})((() => {
      const $0 = Data$dFunctor.arrayMap(Restaumatic$dAnalytics$dTypes$dItem.encodeItem.encode);
      return {encodeWithOptions: v => $0};
    })()))({reflectSymbol: () => "coupon"})({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return v2._1; }
        $runtime.fail();
      }
    }))({reflectSymbol: () => "affiliation"})({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodePurchaseItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericPurchaseItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor({
    reflectSymbol: () => "PurchaseItem"
  })(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
    reflectSymbol: () => "transactionId"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())({reflectSymbol: () => "total"})({
    decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode
  })())({reflectSymbol: () => "shipping"})({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode})())({reflectSymbol: () => "items"})(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.arrayDecode(Restaumatic$dAnalytics$dTypes$dItem.decodeItem);
    return {decodeWithOptions: v => $0.decode};
  })())())({reflectSymbol: () => "coupon"})({decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign.readString(Data$dIdentity.monadIdentity))})())({
    reflectSymbol: () => "affiliation"
  })({decodeWithOptions: v => Foreign.readString(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  PurchaseItem,
  decodePurchaseItem,
  encodePurchaseItem,
  eqPurchaseItem,
  genericPurchaseItem,
  hasFieldPurchaseItem,
  newtypePurchaseItem_,
  showPurchaseItem,
  unscrambleDecodePurchaseItem
};
